/* eslint-disable no-unneeded-ternary */
import React from 'react';

const ProfileNameCard = ({ fname, lname, wrapperClass, profile = '' }) => {
  return (
    <div
      className={`profile-box d-flex align-items-center justify-content-center ${wrapperClass}`}
    >
      {profile ? <img src={profile} alt="" /> : `${fname}${lname}`}
    </div>
  );
};

export default ProfileNameCard;
